const algoliasearch = require('algoliasearch');
const client = algoliasearch('KE0QVNQP97', 'f96be6d3fea639ff472667d9ead02777');

export default () => ({
	loaded: false,
	isAnniversaryModalOpen: false,
	screenWidth: window.innerWidth,
	searchActive: false,
	searchQuery: '',
	searchResults: [],
	isResultsOpen: false,
	isHits: false,

	toggleAnniversaryModal(action) {
		// adds a slight delay between trigger element (year/circle) animation, and slide over animation.
		this.getScreenSize()
		if(this.screenWidth < 1200) {
			if(action === 'open') {
				// set this timeout slightly more than the CSS transition duration of the trigger el (currently 300ms)
				setTimeout(() => {
				this.isAnniversaryModalOpen = true;
				document.querySelector('.left-slider').classList.toggle('hide')
				document.querySelector('.right-slider').classList.toggle('show')
				}, 320)
			} else if(action === 'close') {
				this.isAnniversaryModalOpen = false;
				document.querySelector('.left-slider').classList.toggle('hide')
				document.querySelector('.right-slider').classList.toggle('show')
			}
		}
	},
	getScreenSize() {
		this.screenWidth = window.innerWidth
	},
	toggleSearch() {
		// Run some function...
		this.searchActive = !this.searchActive
		if(this.searchActive) {
			// disable scroll on body
			document.body.style.overflow = 'hidden';
		}
	},
	searchAlgolia(e) {

		e.target.value = '';

		const queries = [
			{
				indexName: 'pages',
				query: this.searchQuery,
			},
			{
				indexName: 'projects',
				query: this.searchQuery,
			},
			{
				indexName: 'news',
				query: this.searchQuery,
			}
		];

		client.multipleQueries(queries).then((res) => {
				this.searchResults = res.results;
				this.isResultsOpen = true;
				if(this.searchResults[0].hits.length > 0 || this.searchResults[1].hits.length > 0 || this.searchResults[2].hits.length > 0) {
					this.isHits = true;
				}
			}
		);

		
				
	},
	resetSearch() {
		this.searchActive = false;
		this.searchQuery = '';
		this.searchResults = [];
		this.isResultsOpen = false;
		this.isHits = false;
		document.body.style.overflow = 'auto';
	},
	exitSearch() {
		this.searchActive = false;
		this.searchQuery = '';
		this.searchResults = [];
		this.isResultsOpen = false;
		this.isHits = false;
		document.body.style.overflow = 'auto';
	},
	init() {
		this.loaded = true
	}
});
